import Page from './components/Page'
import { AGENTS_PAGE } from './pages'

export default {
  [AGENTS_PAGE]: {
    path: '/reports/inbox/organization',
    component: Page,
  },
}
